import { render, staticRenderFns } from "./ProductAddon.vue?vue&type=template&id=7973cd1a&"
import script from "./ProductAddon.vue?vue&type=script&lang=js&"
export * from "./ProductAddon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../b_front/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports